import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './FormFieldError.module.css';
import classNames from 'classnames';

export class FormFieldError extends Component {
    translateMessage() {
        const { message } = this.props;

        if (typeof message === 'object') {
            return <FormattedMessage {...message} values={message.values} />;
        }

        return message;
    }

    render() {
        const { className, hide, message } = this.props;
        const errorMessage = this.translateMessage();
        const formFieldErrorStyles = classNames(
            styles.FormFieldError,
            className
        );

        if (hide || !message) {
            return null;
        }

        return (
            <span data-testid="formErrors" className={formFieldErrorStyles}>
                {errorMessage}
            </span>
        );
    }
}
